import { combineReducers } from '@reduxjs/toolkit';
import { backendApi } from '../services/api';
import bachelor from './bachelor/slice';

const rootReducer = combineReducers({
  bachelor,
  [backendApi.reducerPath]: backendApi.reducer,
});

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer;
